import React from 'react'
import { useSelector } from 'react-redux'

import { lineItemSelector } from '../../../../../../modules/selectors/lineItems'

import { BEHAVIORS } from '../../../../../ReusableFormFields/Audiences/FacebookAudienceFields/FacebookUploadCreativeAudienceFields/AdvancedAudienceTargetingSection/BehavioursSelect/fields'

const BehaviorsSectionPreview = () => {
  const lineItem = useSelector(lineItemSelector)
  const lineItemBehaviors = lineItem[BEHAVIORS]

  if (lineItemBehaviors.length) {
    return lineItemBehaviors.map(behavior => {
      return <p key={behavior.id}>{behavior.name}</p>
    })
  }

  return null
}

export default BehaviorsSectionPreview
